export const Svg_094 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="m31.937 45.355 16.48-16.48-4.157-4.156-12.323 12.323-6.125-6.125-4.156 4.156 10.281 10.282ZM35 64.167c-6.757-1.701-12.335-5.578-16.735-11.63-4.4-6.052-6.599-12.773-6.599-20.162V14.584L35 5.834l23.333 8.75v17.791c0 7.39-2.2 14.11-6.599 20.162-4.4 6.052-9.977 9.929-16.734 11.63Zm0-6.125c5.055-1.604 9.236-4.812 12.541-9.625 3.306-4.812 4.959-10.16 4.959-16.042v-13.78L35 12.031l-17.5 6.562v13.781c0 5.882 1.652 11.23 4.958 16.042 3.306 4.813 7.486 8.02 12.542 9.625Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={22.458}
        x2={52.434}
        y1={14.584}
        y2={53.395}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)